import { BooleanField } from 'module/types/filter-field/field/filterable-field';
import { Checkbox } from 'module/ui/components/atoms/checkbox';
import { HeightStyle } from 'module/ui/components/atoms/input/input';
import { NoValue } from 'module/ui/components/atoms/no-value/empty-cell';
import { FC } from 'react';
import styled from 'styled-components';
import { EditableProps } from './editable-props';

interface Props extends Partial<EditableProps<boolean>> {
  field: BooleanField;
}

const Editor = styled(Checkbox)`
  height: ${HeightStyle};
  display: flex;
  align-items: center;
  padding: 0 var(--cell-padding);
`;

export const BooleanFieldValue: FC<React.PropsWithChildren<Props>> = ({
  field,
  id,
  editable,
  onChange,
}) =>
  !editable ? (
    field.value == null ? (
      <NoValue />
    ) : (
      <Checkbox checked={field.value} />
    )
  ) : (
    <Editor
      data-cy={`ag-grid.${field.type}.editor`}
      id={id}
      checked={field.value || false}
      onChange={(latest) => !!editable && onChange?.(latest.target.checked)}
    />
  );
